import { Component, EventEmitter, Output } from '@angular/core';
import getBlobDuration from 'get-blob-duration'
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-audio-recorder',
  templateUrl: './audio-recorder.component.html',
  styleUrls: ['./audio-recorder.component.scss']
})
export class AudioRecorderComponent {
  mediaRecorder!: MediaRecorder;
  audioChunks: Blob[] = [];
  recording: boolean;
  @Output() isRecording: EventEmitter<boolean>;
  @Output() recordEvent: EventEmitter<Blob>;
  // audioFiles: AudioFile[] = [];

  constructor(
    public commonService:CommonService
  ) {
    this.recording = false;
    this.recordEvent = new EventEmitter();
    this.isRecording = new EventEmitter();
    // Access the user's microphone and start recording
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        this.mediaRecorder = new MediaRecorder(stream);

        this.mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.audioChunks.push(event.data);
          }
        };

        this.mediaRecorder.onstop = () => {
          this.createAudioBlob();
        };
      })
      .catch((error) => {
        console.error('Error accessing microphone:', error);
      });
  }

  startRecording() {
    if (this.mediaRecorder && !this.recording) {
      this.audioChunks = []; // Reset the audioChunks array
      this.mediaRecorder.start();
      this.recording = true;
      this.isRecording.emit(true);
    }
  }

  stopRecording() {
    if (this.mediaRecorder && this.recording) {
      this.mediaRecorder.stop();
      this.recording = false;
      this.isRecording.emit(false);
    }
  }

  createAudioBlob() {
    if (this.audioChunks.length > 0) {
      let audioBlob = new Blob(this.audioChunks, { type: 'audio/wav ;codecs=0'});
      getBlobDuration(audioBlob).then((duration) => {
        this.commonService.RecordedAudioDuration = duration;
    });
     let audioWav = this.blobToFile(audioBlob,'Recorded_audio.webm');
      this.recordEvent.emit(audioWav);
    }
  }

  public blobToFile = (theBlob: Blob, fileName:string): File => {
    const b: any = theBlob;
    b.lastModifiedDate = new Date();
    b.name = fileName;
    const file = new File([b], b.name, { type: b.type });
    return file;
  }


  manageRecording() {
    if(this.recording) {
      // recording already started
      this.stopRecording();
    }else {
      // recording was stopped
      this.startRecording();
    }
  }
}
